import { FaChevronDown, FaUserFriends, FaWallet, FaCopy, FaCheck } from "react-icons/fa";
import { FaSackDollar } from "react-icons/fa6";

import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ITreasureContract ,DepositContract} from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import Loader from "../components/Loader";
import DepositAbi from "../abis/DepositAbi.json";

import React, { useEffect, useState } from "react";

const AffiliateDetails = () => {

  const [copiedWallet, setCopiedWallet] = useState(false);
  const [copiedReferral, setCopiedReferral] = useState(false);

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);

    if (type === "wallet") {
      setCopiedWallet(true);
      setTimeout(() => setCopiedWallet(false), 1500);
    }

    if (type === "referral") {
      setCopiedReferral(true);
      setTimeout(() => setCopiedReferral(false), 1500);
    }
  };

  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();
  const [web3, setWeb3] = useState(null);
  const [objUser, setObjUser] = useState({});
  const [teamDetails, setTeamDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [totalDirectTradingFund, setTotalDirectTradingFund] = useState(0);

  const [totalTeamTradingFund, setTotalTeamTradingFund] = useState(0);
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client && client.transport) provider = client.transport;
      else if (typeof window !== "undefined" && window.ethereum)
        provider = window.ethereum;

      if (!provider) {
        setWeb3(null);
        return;
      }

      const w3 = new Web3(provider);
      setWeb3(w3);

      if (provider.on) {
        provider.on("accountsChanged", (accounts) => {
          if (accounts.length > 0) fetchData();
        });

        provider.on("chainChanged", () => {
          if (address) fetchData();
        });
      }
    };
    initWeb3();
  }, [client]);

  useEffect(() => {
    if (isConnected && address && web3) {
      fetchData();
    }
  }, [address, isConnected, web3]);

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const GGTInstance = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);

      const _objUser = await GGTInstance.methods.objUser(address).call();
      setObjUser({
        userId: _objUser.userId,
        referral: _objUser.referral,
        registrationTimeStamp: _objUser.registrationTimeStamp,
        totalSelfPurchasing: web3.utils.fromWei(_objUser.totalSelfPurchasing, "ether"),
        lastSelfPurchasing: web3.utils.fromWei(_objUser.lastSelfPurchasing, "ether"),
        lastPurchasingTimeStamp: _objUser.lastPurchasingTimeStamp,
        lastActivePackage  :_objUser.lastActivePackage,
        totalDirectPurchased: web3.utils.fromWei(_objUser.totalDirectPurchased, "ether"),
        totalTeamPurchased: web3.utils.fromWei(_objUser.totalTeamPurchased, "ether")
      });

      const _team = await GGTInstance.methods.getTeamDetails(address).call();

      // ==============================
// 🔥 GET DIRECT USERS
// ==============================
const slot = 0;
const level = 0;

const members = await GGTInstance.methods
  .getFetchLevel(address, slot, level)
  .call();

const validMembers = members.filter(
  (w) =>
    w &&
    w !== "0x0000000000000000000000000000000000000000" &&
    w !== ""
);

// ==============================
// 🔥 SUM THEIR TRADING FUND
// ==============================
let totalFund = 0;

const DepositInstance = new web3.eth.Contract(DepositAbi, DepositContract);

for (let i = 0; i < validMembers.length; i++) {
  const user = validMembers[i];

  try {
    const cappingData = await DepositInstance.methods
      .getTradingIncomeCapping(user)
      .call();

    const fund = Number(
      web3.utils.fromWei(cappingData.totalDepositFunds, "ether")
    );

    totalFund += fund;
  } catch (err) {
    console.log("Error in fund:", err);
  }
}

// 🔥 FINAL SET
setTotalDirectTradingFund(totalFund);

// ==============================
// 🔥 FULL TEAM (18 LEVEL)
// ==============================
const totalLevels = 18;
let totalTeamFund = 0;

const DepositInstance2 = new web3.eth.Contract(DepositAbi, DepositContract);

for (let lvl = 0; lvl < totalLevels; lvl++) {
  try {
    const members = await GGTInstance.methods
      .getFetchLevel(address, 0, lvl)
      .call();

    const valid = members.filter(
      (w) =>
        w &&
        w !== "0x0000000000000000000000000000000000000000" &&
        w !== ""
    );

    for (let i = 0; i < valid.length; i++) {
      const user = valid[i];

      try {
        const cappingData = await DepositInstance2.methods
          .getTradingIncomeCapping(user)
          .call();

        const fund = Number(
          web3.utils.fromWei(
            cappingData.totalDepositFunds,
            "ether"
          )
        );

        totalTeamFund += fund;
      } catch (err) {
        console.log("Team fund error:", err);
      }
    }
  } catch (err) {
    console.log("Level error:", err);
  }
}

// 🔥 FINAL TEAM TOTAL
setTotalTeamTradingFund(totalTeamFund);

      setTeamDetails({
        totalDirect: _team[0].map(n => Number(n)),
        noOfTotalTeam: _team[1].map(n => Number(n)),
        totalDirectBusiness: _team[2].map(n => web3.utils.fromWei(n.toString(), "ether")),
        totalTeamBusiness: _team[3].map(n => web3.utils.fromWei(n.toString(), "ether")),
        totalDirectPurchased: web3.utils.fromWei(_team[4], "ether"),
        totalTeamPurchased: web3.utils.fromWei(_team[5], "ether")
      });

    }
    catch (error) {
      console.error("Error Fetching Data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const formatBalance = (balance) => balance ? parseFloat(balance).toFixed(2) : "0.00";

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <section className="services-one">
        <div className="card   bonus-card-sm">
          <div className="card-body">

            <h4 className="text-white mb-3"><span className="text-warning"> Affiliate</span> <span className="fw-lighter"> Details</span> </h4>

            <div className="row">
              <div className="col-md-6 mb-3">   
                <h6  className="text-white">Connected Wallet</h6>         {/* Connected Wallet */}
                <div className="referralBoxMain">
                  <div className="referralBoxIcon"><FaWallet /></div> 
                  <div className="referralBoxAddress">{address}</div>

                  <button
                    className="referralBoxCopyBtn"
                    onClick={() => copyToClipboard(address, "wallet")}
                  >
                    {copiedWallet ? (
                      <>
                        <FaCheck /> <span className="copy-text">Copied</span>
                      </>
                    ) : (
                      <>
                        <FaCopy /> <span className="copy-text">Copy</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                {/* Referral */}
              <h6 className="text-white">Referred By</h6>
                <div className="referralBarMain">
                  <div className="referralBarIcon"><FaUserFriends /></div>

                  <div className="referralBarText">{objUser.referral}</div>

                  <button
                    className="referralBarCopyBtn"
                    onClick={() => copyToClipboard(objUser.referral, "referral")}
                  >
                    {copiedReferral ? (
                      <>
                        <FaCheck /> <span className="copy-text">Copied</span>
                      </>
                    ) : (
                      <>
                        <FaCopy /> <span className="copy-text">Copy</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

 
            <div className="row card-row">
              <Card
                icon={<FaUserFriends />}
                title="My User ID"
                value={objUser.userId ? String(objUser.userId) : "0"}
              /> 
              <Card icon={<FaSackDollar />} title="My Investment" value={formatBalance(objUser.totalSelfPurchasing)}unit="USDT" />
              <Card icon={<FaUserFriends />} title="Total Direct" value={teamDetails.totalDirect ? teamDetails.totalDirect[0] : 0} />
              <Card icon={<FaSackDollar />} title="Direct Team Investment" value={formatBalance(objUser.totalDirectPurchased)}unit="USDT" />
              <Card icon={<FaUserFriends />} title="Total Team" value={teamDetails.noOfTotalTeam ? teamDetails.noOfTotalTeam[0] : 0} />
              <Card icon={<FaSackDollar />} title="All Team Investment" value={formatBalance(objUser.totalTeamPurchased)}unit="USDT" />
              <Card
  icon={<FaSackDollar />}
  title="Direct Team Trading Fund"
  value={totalDirectTradingFund.toFixed(4)}
  unit="USDT"
/>
<Card
  icon={<FaSackDollar />}
  title="Total Team Trading Fund"
  value={totalTeamTradingFund.toFixed(4)}
  unit="USDT"
/>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default AffiliateDetails;


const Card = ({ icon, title, value,unit  }) => (
<div className="col-lg-4 col-md-4 col-sm-6 mb-3">
  <div className="earnCardX">
    <div className="earnCardX_inner">
      <div className="earnCardX_icon">{icon}</div>
      <div className="earnCardX_valueWrapper">
        <span className="earnCardX_value">{value}</span>
        {/* <span className="earnCardX_unit"></span> */}
        <span className="earnCardX_unit">
            {unit ? unit : ""}
          </span>
      </div>
      <div className="earnCardX_title">{title}</div>
    </div>
  </div>
</div>
);
